import { routeCatalog } from "../contracts/catalog.js";
import { createClientContext } from "../internal/transport.js";
import { buildAddressRoutes } from "../routes/addresses.js";
import { buildBlockRoutes } from "../routes/blocks.js";
import { buildGovernanceSearchRoutes } from "../routes/governanceSearch.js";
import { buildLiveRoutes } from "../routes/live.js";
import { buildMetricsRoutes } from "../routes/metrics.js";
import { buildRawRoutes, buildStatusRoutes } from "../routes/statusRaw.js";
import { buildStreamRoutes } from "../routes/stream.js";
import { buildTransactionRoutes } from "../routes/transactions.js";
import { buildValidatorRoutes } from "../routes/validators.js";
/**
 * Create one typed Hyphen API client bound to a daemon base URL.
 */
export function createClient(options) {
    const context = createClientContext(options);
    return {
        addresses: buildAddressRoutes(context),
        blocks: buildBlockRoutes(context),
        descriptors: routeCatalog,
        governanceSearch: buildGovernanceSearchRoutes(context),
        live: buildLiveRoutes(context),
        metrics: buildMetricsRoutes(context),
        raw: buildRawRoutes(context),
        status: buildStatusRoutes(context),
        stream: buildStreamRoutes(context),
        transactions: buildTransactionRoutes(context),
        validators: buildValidatorRoutes(context),
    };
}
//# sourceMappingURL=createClient.js.map